import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import "./email.css";
const EmailInput = () => {
  return (
    <div className="input-container1">
      <span className="icon">
        <FontAwesomeIcon icon={faEnvelope} />
      </span>
      <input type="text" placeholder="Enter your email" />{" "}
      <button className="btn btn-black1">
        <span className="button-text">Subscribe Now</span>
      </button>
    </div>
  );
};

export default EmailInput;
